export const getContextString = movementType => {
  switch (movementType) {
    case 'collections':
      return 'W::Collection';
    case 'deliveries':
      return 'W::Delivery';
    case 'imports':
      return 'W::Import';
    case 'exports':
      return 'W::Export';
  }
};
